<template>
  <div
    class="boxes-container"
    :class="{ 'edit-appointment': currentRoute === 'AppointmentDetail' }"
  >
    <template
      v-if="
        !getEdit.isEdit ||
          (getEdit.isEdit && editLevel === 0) ||
          (getEdit.isEdit && editLevel >= 2)
      "
    >
      <!-- Select contact -->
      <add-contact-unified :add-option-selected="addOptionSelected" />

      <!-- Date -->
      <date />

      <!-- Start and end time -->
      <div v-if="!getAllDay">
        <start-time />
        <end-time />
      </div>

      <!-- Middle -->
      <middle-vue />

      <!-- Repeat -->
      <repeat-vue :client-or-other-clicked="clientOrOtherClicked" />

      <!-- Start and end time -->
      <!-- <div v-if="repeatValue !== 'Never'">
        <start-date-vue />
        <end-date-vue :client-or-other-clicked="clientOrOtherClicked" />
      </div> -->

      <!-- Provider -->
      <provider-vue :client-or-other-clicked="clientOrOtherClicked" />

      <!-- Office location -->
      <office-location-vue :client-or-other-clicked="clientOrOtherClicked" />

      <!-- Type -->
      <div class="heading-appoitment brd-top">Type</div>
      <is-video-vue />
      <transition name="fade-full">
        <video-expansion
          v-if="
            getIsVideo &&
              !(
                appointmentTypeType === 'others' &&
                appointmentTypeOtherType === 'event'
              ) &&
              addVideoAppointmentPermission
          "
        />
      </transition>

      <!-- Notes -->
      <notes-vue />
      <div class="seprator top padding-none"></div>
    </template>
  </div>
</template>

<script>
import AddContactUnified from "./Form/AddContactUnified";
import MiddleVue from "./Form/Middle.vue";
import RepeatVue from "./Form/Repeat.vue";
import ProviderVue from "./Form/Provider.vue";
import OfficeLocationVue from "./Form/OfficeLocation.vue";
import IsVideoVue from "./Form/IsVideo.vue";
import NotesVue from "./Form/Notes.vue";
import StartTime from "./Form/StartTime.vue";
import EndTime from "./Form/EndTime.vue";
import Date from "./Form/Date.vue";
import VideoExpansion from "./Form/VideoExpansion.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    editLevel: Number,
    firstClick: Boolean,
    setEditLevel: Function,
    setFirstClick: Function,
    popup: Function,
    addOptionSelected: Function // When add client/person/event/group option is selected
  },
  data() {
    return {
      currentRoute: "", // The current route
      clientOrOtherClicked: false // Client or other clicked
    };
  },
  components: {
    AddContactUnified, // Add contact unfied for selecting a contact
    MiddleVue,
    RepeatVue,
    OfficeLocationVue,
    IsVideoVue,
    NotesVue,
    ProviderVue,
    VideoExpansion,
    StartTime,
    EndTime,
    Date
  },
  computed: {
    ...mapGetters({
      getRepeat: "getRepeat", // Get the repeat details
      getIsVideo: "getIsVideo", // Get if it is a video appointment
      getAllDay: "getAllDay", // Get if the appointment is all day
      getAppointmentType: "getAppointmentType", // Get weather appointment type
      addVideoAppointmentPermission: "getAddVideoAppointmentPermission", // Get weather the user has permission to add video appointment
      getEdit: "getEdit" // Get weather we are supposed to add or edit
    }),
    /**
     * Check if this is a repeat appointment or not
     */
    repeatValue() {
      return this.getRepeat[this.getRepeat.innerOrOuter + "Options"][
        this.getRepeat.selectedIndex
      ];
    },
    appointmentTypeType() {
      return this.getAppointmentType.type;
    },
    appointmentTypeOtherType() {
      return this.getAppointmentType.otherType;
    }
  },
  methods: {
    ...mapActions({
      getFormDetails: "getFormDetails" // Get form details from the server
    }),
    setClientOrOtherClicked(value) {
      this.clientOrOtherClicked = value;
    }
  },
  created() {
    this.currentRoute = this.$router.history.current.name; // Set the current route
    this.getFormDetails(); // If form details have already been brought in, it won't be brought again
  }
};
</script>

<style>
.fade-full-enter {
  opacity: 0;
}

/* stage 2. Entered */
.fade-full-enter-active {
  transition: opacity 0.3s ease-in-out;
}

/* stage 3. leave */
.fade-full-leave-active {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.slide-left-enter-active {
  animation: slide-in-left 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.slide-left-leave-active {
  animation: slide-out-left 0.2s ease-in-out forwards;
  position: absolute;
}

.slide-left-move {
  transition: transform 0.2s ease-in-out;
}

@keyframes slide-in-left {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slide-out-left {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(-100%);
  }
}
</style>
